import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

const ClientLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        {children || <Outlet />}
      </main>
      <Footer />
    </>
  );
};

export default ClientLayout;